/**
 * 해석 텍스트 후처리.
 *
 * LLM이 드물게 본문 끝에 의미 없는 토큰을 붙여 내보낸다.
 * 실측: "…검사나 치료가 필요하다면 전문가와 함께 결정해 주세요.ikarresp"
 *       (gpt-5.6-luna, prompt v0.4, 2026-08-19 — DB 저장본에서 확인)
 * 스트리밍 중에는 어디가 끝인지 알 수 없어 막을 수 없으므로, 스트림이 끝난 시점에
 * 한 번 정리한다. 화면 표시와 저장 양쪽이 같은 함수를 거치게 할 것.
 */

/**
 * 해석 생성 실패 안내 — **provider의 에러 원문을 절대 사용자에게 보내지 않는다.**
 * 실측: OpenAI가 프롬프트를 정책 필터로 거부하면 영어 장문+URL이 err.message로 온다
 * ("Invalid prompt: your prompt was flagged…", 2026-08-21). 원문은 서버 로그(Sentry)로만.
 */
export const AI_FAILED_MESSAGE = '해석을 만들지 못했어요. 잠시 후 다시 시도해 주세요 🙏';

/** 문장 종결 부호 뒤에 공백 없이 달라붙은 로마자 덩어리의 최대 길이 */
const TRAILING_JUNK_MAX = 24;

/**
 * 꼬리에 붙는 **대괄호 메타 표기** 최대 길이.
 * 실측: "…작은 설렘을 가볍게 지나치지 마세요. [문장 완결 필요]" (2026-08-21)
 * 프롬프트의 "마지막 문장까지 완결해 주세요"를 모델이 독자에게 보이는 메모로 옮겨 적은 것이다.
 */
const TRAILING_NOTE_MAX = 20;

/**
 * 꼬리에 붙은 잡음 제거. 두 가지를 지운다.
 *
 * 1. 문장 종결 부호(`.`, `!`, `?`, `…`) **바로 뒤에 공백 없이** 붙은 로마자.
 *    한국어 본문에서 이런 형태는 정상적으로 나오지 않는다 — "MBTI", "The Fool"처럼
 *    정상적인 로마자는 앞에 공백이 있거나 문장 중간에 온다.
 * 2. 본문 **맨 끝**의 짧은 대괄호 메모(`[문장 완결 필요]` 등). 문장 부호가 들어 있지 않은
 *    짧은 것만 지운다 — 본문 중간의 대괄호나 긴 인용은 건드리지 않는다.
 *
 * 판단이 서지 않으면 건드리지 않는 쪽을 택했다: 본문을 깎는 쪽이 잡음보다 나쁘다.
 */
export function cleanInterpretation(text: string): string {
  return text
    .replace(new RegExp(`([.!?…])[A-Za-z]{2,${TRAILING_JUNK_MAX}}\\s*$`), '$1')
    .replace(new RegExp(`\\s*\\[[^\\].!?\\n]{1,${TRAILING_NOTE_MAX}}\\]\\s*$`), '')
    .trimEnd();
}
